export type InvestigationDashboardWidgetDataType =
  | 'distribution'
  | 'count'
  | 'timeseries'
  | 'rank'
  | 'pair'
  | 'stub';

export class InvestigationDashboardWidgetDataPointEntity {
  public key!: string;
  public label!: string;
  public value!: number;
  public color!: string | null;
  public filter!: string | null;
}

export class InvestigationDashboardWidgetDataEntity {
  public widgetKey!: string;
  public type!: InvestigationDashboardWidgetDataType;
  public data!: InvestigationDashboardWidgetDataPointEntity[];
}
